import SplitTextSystem from './SplitTextSystem';
import './SplitTextSystem.scss';

export default SplitTextSystem;
